

// import React, { useState } from 'react';
// import banner from "../../assets/Images/HomePage5/banner.png";
// import play from "../../assets/Images/HomePage5/Play.png";
// import "./HomePageFive.css"
// import video from '../../assets/videomicro.mp4';
 
// function HomePageFive() {
//   const [showVideo, setShowVideo] = useState(false);
 
//   const handlePlayClick = () => {
//     setShowVideo(true);
//   };
 
//   const closeVideo = () => {
//     setShowVideo(false);
//   };
 
//   return (
//     <div
//       className='container-fluid organic-farm-banner mt-4'
//       style={{
//         backgroundImage: `url(${banner})`,
//       }}
//     >
//       <div className='banner-content'>
//         {/* <h1 className='ff-poppins fs-36 fc-white fw-600 banner-title'>Digitizing Agriculture Empowering Farmers</h1> */}
//         <h1 class="banner-title">
//   <span class="line-bg">Digitizing Agriculture</span>
//   <span class="line-bg">Empowering Farmers</span>
// </h1>

//         <img
//           src={play}
//           alt='play button'
//           className='play-button'
//           onClick={handlePlayClick}
//         />
 
//         {/* Video Popup Modal */}
//         {showVideo && (
//           <div className="video-popup-overlay" onClick={closeVideo}>
//             <div className="video-popup-container" onClick={e => e.stopPropagation()}>
//               <button className="video-popup-close" onClick={closeVideo}>
//                 &times;
//               </button>
//               <video
//                 className='intro-video'
//                 src={video}
//                 controls
//                 autoPlay
//                 muted
//                 playsInline
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
 
// export default HomePageFive;


import React from 'react';
import video from '../../assets/videomicro.mp4';
import './HomePageFive.css';

function HomePageFive() {
  return (
    <div className="organic-farm-banner">
      <video
        className="background-video"
        src={video}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="banner-content">
        <h1 className="banner-title">
          <span className="line-bg">Digitizing Agriculture</span>
          <span className="line-bg">Empowering Farmers</span>
        </h1>
      </div>
    </div>
  );
}

export default HomePageFive;
